import * as React from "react";
const SvgPlus = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path stroke="#191919" strokeLinecap="round" strokeLinejoin="round" d="M9 15.5v-12M15 9.5H3" />
  </svg>
);
export default SvgPlus;
